.labels {
    box-sizing: border-box;
    width: 100%;
    margin-top: 8px;
    margin-bottom: 16px;
}
